// line-height tokens from master-design-system.json → typography.EPIC.line-height
// heading variants scale to 1.2×; para variants scale to 1.5×
export type LineHeightToken =
  | "2xs"       // 10px
  | "xs"        // 12px
  | "s-heading" // 16.8px  (14px × 1.2)
  | "s-para"    // 21px    (14px × 1.5)
  | "m-heading" // 19.2px  (16px × 1.2)
  | "m-para"    // 24px    (16px × 1.5)
  | "2m-heading"// 21.6px  (18px × 1.2)
  | "2m-para"   // 27px    (18px × 1.5)
  | "l"         // 24px
  | "xl"        // 28.8px
  | "2xl"       // 36px
  | "3xl"       // 57.6px

export const lineHeightClasses: Record<LineHeightToken, string> = {
  "2xs":        "leading-none",                           // 10px ÷ 10px = 1.0
  "xs":         "leading-none",                           // 12px ÷ 12px = 1.0
  "s-heading":  "leading-[var(--line-height-s-heading)]", // token: 16.8px (14px × 1.2)
  "s-para":     "leading-[1.5]",                          // 21px ÷ 14px = 1.5
  "m-heading":  "leading-[1.2]",                          // 19.2px ÷ 16px = 1.2
  "m-para":     "leading-[1.5]",                          // 24px ÷ 16px = 1.5
  "2m-heading": "leading-[1.2]",                          // 21.6px ÷ 18px = 1.2
  "2m-para":    "leading-[1.5]",                          // 27px ÷ 18px = 1.5
  "l":          "leading-[1.2]",                          // 24px ÷ 20px = 1.2
  "xl":         "leading-[1.2]",                          // 28.8px ÷ 24px = 1.2
  "2xl":        "leading-[1.2]",                          // 36px ÷ 30px = 1.2
  "3xl":        "leading-[1.2]",                          // 57.6px ÷ 48px = 1.2
}
